export { default as DotSeparatedTitle } from './dotSeparatedTitle.container';
